export const getUrlAsFile = async (url: string, filename = 'filename') => {
  const data = await fetch(url)
    .then(response => response.blob())
    .catch(() => new Blob([], { type: 'image/png' }));

  return new File([data], filename, { type: data.type });
};
